module.exports = __webpack_public_path__ + "assets/388b1371da89d0ba12477be0410c9cdd.mp3";